import {useConnectionsStore} from "@/stores/ConnectionsStore";
import axios from "axios";

export default {

    methods: {

        async changePasswordProcessChangePassword(currentPassword, newPassword) {

            let self = this;
            let params = {};

            params.currentPassword = currentPassword;
            params.newPassword = newPassword;

            return await axios.get('change_password.php', {
                params
            }).then((response) => {
                return response.data
            }).catch((error) => {
                // TODO: Log error
                console.log(error)
                return false
            })
        }
    }

}
